import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="footer">
                <h3>Start using towva</h3>
                <div className="cat-sect div-cent">
                    <div className="cat-downloads">
                        <div>
                        <a href="https://portal.towva.co/user_app"><img src={require("./../images/play-store.png")} width="100%" alt=""/></a>
                        </div>
                        <div></div>
                        <div>
                            <a href="https://portal.towva.co/user_app"><img src={require("./../images/app-store.png")} width="100%" alt=""/></a>
                        </div>
                    </div>
                </div>
                <div className="link-section">
                    <div className="row">
                        <div className="col-sm-4">
                            <h5>Our Products</h5>
                            <ul>
                                <li><Link to="/not-available">Tow truckers</Link></li>
                                <li><Link to="/not-available">Mechanics</Link></li>
                                <li><Link to="/not-available"></Link></li>
                                <li><Link to="/not-available"></Link></li>
                            </ul>
                            <div className="non"></div>
                        </div>
                        <div className="col-sm-4">
                            <h5>About Us</h5>
                            <ul>
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/user-info">Users</Link></li>
                                <li><Link to="/trucker-info">Truckers</Link></li>
                                <li><Link to="/trucker-registration">Register Trucker</Link></li>
                                <li><Link to="/company-registration">Register Company</Link></li>
                                <li><Link to="/not-available">Cities</Link></li>
                                <li><Link to="/not-available">Careers</Link></li>
                            </ul>
                            <div className="non"></div>
                        </div>
                        <div className="col-sm-4">
                            <h5>Contact us</h5>
                            <p>
                                Reachout:<br/>
                                <a href="mailto:info@towva.co">info@towva.co</a>
                            </p>
                            <p>
                                Support:<br/>
                                <a href="mailto:Customer@towva.co">Customer@towva.co</a>
                            </p>
                            <ul className="social-media">
                                <li><a href="https://www.facebook.com/towva.co/"><i className="fab fa-facebook"></i></a></li>
                                <li><a href="https://twitter.com/CoTowva"><i className="fab fa-twitter"></i></a></li>
                                <li><a href="https://www.instagram.com/towva.co/"><i className="fab fa-instagram"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <p className="cent">&copy; Towva Ltd. All rights Reserved</p>
            </div>
         );
    }
}
 
export default Footer;